import {
	getMvcApplicationHeaders,
	getWebApiUrl,
	httpClient,
	UserTypes,
} from "@utils";

import { IBetSlipRequestOptions } from "@gp/slip";
import { BetSlipResultExtended } from "@api-types/bet-slip/BetSlipResultExtended";

export class SlipApiService {
	static baseUrl() {
		return `${getWebApiUrl()}/api/slip`;
	}

	static getOptions = (
		options: IBetSlipRequestOptions | undefined = undefined
	) => {
		options = options || {};
		options.responseType = "json";

		return options;
	};

	static getMvcRequestHeaders = (walletOwner = UserTypes.PRIMARY) => {
		const appHeaders = getMvcApplicationHeaders(walletOwner);
		appHeaders["Content-Type" as keyof HeadersInit] = "application/json";
		return appHeaders;
	};

	static async delay(
		userTypes: UserTypes = UserTypes.PRIMARY
	): Promise<{ value: number; level: number }> {
		const options = this.getOptions();

		return await httpClient.get(
			`${this.baseUrl()}/delay`,
			this.getMvcRequestHeaders(userTypes),
			options
		);
	}

	static async getSlipByEncryptedBetSlipNumber(
		encryptedBetSlipNumber: string
	): Promise<BetSlipResultExtended> {
		const options = this.getOptions(undefined);
		return await httpClient.get(
			`${this.baseUrl()}/check-bet-slip/${encryptedBetSlipNumber}`,
			this.getMvcRequestHeaders(),
			options
		);
	}
}
